import React, { FC, lazy, Suspense } from 'react';
import { useRouteMatch } from 'react-router-dom';
import HTML5Backend from 'react-dnd-html5-backend';
import { DndProvider } from 'react-dnd';

import MainLayout from '../../components/layout/MainLayout/main';
import { ResizeHandler, RouteWrapper } from '../../components';

const SingleMessage = lazy(() => import('../SingleMessage'));
const Mailbox = lazy(() => import('../Mailbox'));

export const OverviewRoutes: FC = ({ children }) => {
    const redirectFromOverview = useRouteMatch('/mailboxid/:mailboxId/messageid/:messageId');
    const redirectFromWriteNew = useRouteMatch('/mailboxid/:mailboxId');
    if (redirectFromOverview) {
        return (
            <ResizeHandler>
                <Suspense fallback={null}>
                    <DndProvider backend={HTML5Backend}>
                        <RouteWrapper
                            path="/mailboxid/:mailboxId/messageid/:messageId"
                            component={SingleMessage}
                            layout={MainLayout}
                            disableCustomScroll
                        />
                    </DndProvider>
                </Suspense>
            </ResizeHandler>
        );
    }
    if (redirectFromWriteNew) {
        return (
            <ResizeHandler>
                <Suspense fallback={null}>
                    <DndProvider backend={HTML5Backend}>
                        <RouteWrapper
                            path="/mailboxid/:mailboxId"
                            component={Mailbox}
                            layout={MainLayout}
                            disableCustomScroll
                        />
                    </DndProvider>
                </Suspense>
            </ResizeHandler>
        );
    }

    return <>{children}</>;
};
